module.exports = __webpack_public_path__ + "img/profile-circle-linear-24x24.bbff0b83.svg";